// 平台商户号支持的全部支付通道类型（与「应用服务-平台商户号」通道枚举保持一致）
// TODO: 联调时替换为接口数据（支付通道字典）
export const PAYMENT_CHANNELS = [
  { value: 'wechat', label: '微信' },
  { value: 'wechat_mini', label: '微信小程序' },
  { value: 'alipay', label: '支付宝' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'applepay', label: 'Apple Pay' },
  { value: 'googlepay', label: 'Google Pay' },
  { value: 'payssion', label: 'Payssion' },
  { value: 'zarinpal', label: 'ZARINPAL' },
  { value: 'airwallex', label: 'AIRWALLEX' },
  { value: 'stripe', label: 'STRIPE' },
  { value: 'fuyou', label: '富友支付' },
];

export const PAYMENT_CHANNEL_LABEL = PAYMENT_CHANNELS.reduce((m, c) => {
  m[c.value] = c.label;
  return m;
}, {});

// 平台代收款带出用：平台商户号在各通道上的费率（按企业 App 实际引用的商户号取）
// TODO: 联调时替换为接口数据
export const MOCK_PLATFORM_MERCHANT_FEES = {
  wechat: { rate: 0.60, fixedFeeCny: 0.30 },
  alipay: { rate: 1.50, fixedFeeCny: 0.90, fixedFeeUsd: 0.15 },
  paypal: { rate: 3.50, fixedFeeUsd: 0.50 },
  applepay: { rate: 2.00 },
  stripe: { rate: 2.90 },
};

export const isEmptyFee = (fee) => !fee
  || (fee.rate == null && fee.fixedFeeCny == null && fee.fixedFeeUsd == null);

export const countConfiguredFees = (fees = {}) =>
  PAYMENT_CHANNELS.filter((c) => !isEmptyFee(fees[c.value])).length;

export const getConfiguredFeeList = (fees = {}) =>
  PAYMENT_CHANNELS
    .filter((c) => !isEmptyFee(fees[c.value]))
    .map((c) => ({ ...c, fee: fees[c.value] }));

export const formatFeeText = (fee) => {
  if (isEmptyFee(fee)) return '未配置';
  const parts = [];
  if (fee.rate != null) parts.push(`${Number(fee.rate).toFixed(2)}%`);
  if (fee.fixedFeeCny != null) parts.push(`¥${Number(fee.fixedFeeCny).toFixed(2)}`);
  if (fee.fixedFeeUsd != null) parts.push(`$${Number(fee.fixedFeeUsd).toFixed(2)}`);
  return parts.join(' + ');
};

export const pullMerchantFees = () => Object.entries(MOCK_PLATFORM_MERCHANT_FEES)
  .reduce((m, [channel, fee]) => { m[channel] = { ...fee }; return m; }, {});
